<template>
  <div class="tools">
    <vue-headful title="ITT流体技术" description="ITT流体技术" />
    <div class="container">
      <div class="header">
        <div class="left"></div>
        <div class="right"></div>
      </div>
      <div class="main">
        <img class="main-img1" src="@/assets/spxflow-logo-2C.png" alt="" />
        <img class="main-img2" src="@/assets/main/tools/background.png" alt="" />
        <img class="main-img3" src="@/assets/main/tools/img2.png" alt="" />
        <img class="main-img4" src="@/assets/main/tools/circle.png" alt="" />
        <div class="list">
          <a href="/query/#/product" class="item">
            <img class="item-icon1" src="@/assets/main/tools/icon2.png" alt="" />
            <img class="item-img2" src="@/assets/main/tools/01.png" alt="" />
            <h3>阀门新老备件号查询</h3>
            <p>点击进入</p>
          </a>
          <a href="/query/#/valve" class="item">
            <img class="item-icon2" src="@/assets/main/tools/icon3.png" alt="" />
            <img class="item-img2" src="@/assets/main/tools/02.png" alt="" />
            <h3>阀门专用工具查询</h3>
            <p>点击进入</p>
          </a>
          <a href="/query/#/search" class="item">
            <img class="item-icon3" src="@/assets/main/tools/icon5.png" alt="" />
            <img class="item-img2" src="@/assets/main/tools/03.png" alt="" />
            <h3>阀门备件包查询</h3>
            <p>点击进入</p>
          </a>
          <a href="/query/#/search2" class="item">
            <img class="item-icon4" src="@/assets/main/tools/icon4.png" alt="" />
            <img class="item-img2" src="@/assets/main/tools/04.png" alt="" />
            <h3>泵备件包查询</h3>
            <p>点击进入</p>
          </a>
        </div>
      </div>
    </div>
    <div class="footer">
      <img src="@/assets/footer.png" alt="" />
      <!-- <div class="top"></div>
      <div class="content">
        <div class="qr">
          <img src="@/assets/qr.jpeg" alt="" />
        </div>
        <div class="info">
          <h5>长按左侧二维码关注,了解更多</h5>
          <p>斯必克流体中国</p>
          <p>网址：spxflow.com/cn</p>
          <p>电话：86-21-2208 5888</p>
          <p>售后服务电话：4001-528-008</p>
          <p>邮箱：china.contact@spxflow.com</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {};
  },
  methods: {
    authenticate() {
      // let url = encodeURIComponent(location.href)
      // let appId = 'wxa835709a6a52c7bc'
      // let state = 'stateless'
      // location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`
    },
  },

  mounted() {
    // this.authenticate();
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 221px);
  .header {
    height: 15px;
    background-color: #1d4f48;
    display: flex;
    .left {
      flex: 1 0 62.4%;
    }
    .right {
      flex: 1 0 37.6%;
      background-color: #ccc;
    }
  }

  .main {
    margin-top: 40px;
    text-align: center;
  }

  .main-img1 {
    width: 250px;
  }

  .main-img2 {
    width: 77.3%;
    margin-top: 35px;
    margin-left: 40px;
  }

  .main-img3 {
    width: 74.6%;
    position: absolute;
    top: 250px;
    right: 1px;
    z-index: -1;
  }

  .main-img4 {
    width: 17.5px;
    height: 17.5px;
    position: absolute;
    top: 512px;
    left: 2.5px;
  }

  .list {
    margin: 3px auto 0 auto;
  }

  .list a:nth-child(even) {
    margin-left: 20px;
  }

  .item {
    display: inline-block;
    background-color: #fff;
    color: rgba(88, 88, 88, 1);
    padding: 12px 11px 12px 16px;
    text-align: left;
    margin-bottom: 14px;
    border-radius: 10px;
    box-shadow: 0px 3.5px 20px 0px rgba(12, 74, 89, 0.1);
    /* font-family: Georgia, "Times New Roman", "Microsoft YaHei", "微软雅黑", STXihei, "华文细黑", serif; */
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  }

  .item-icon1 {
    width: 40px;
    height: 40px;
    vertical-align: top;
  }

  .item-icon2 {
    width: 41.5px;
    height: 41.5px;
    vertical-align: top;
  }

  .item-icon3 {
    width: 13px;
    height: 41.5px;
    margin-right: 13px;
    margin-left: 13.5px;
    vertical-align: top;
  }

  .item-icon4 {
    width: 37.5px;
    height: 25px;
  }

  .item-img2 {
    width: 59px;
    height: 42px;
    margin-left: 18px;
  }

  h3 {
    font-size: 12px;
    font-weight: bold;
    margin: 0;
    margin-top: 8px;
    margin-bottom: 9px;
    /* font-family: Source Han Sans SC; */
  }

  p {
    font-size: 10px;
    font-weight: 400;
    color: rgba(0, 0, 0, 1);
    margin: 0;
    /* font-family: Source Han Sans SC; */
  }
}

// .footer {
//   margin-top: 30px;
//   border-bottom: 15px solid #686767;
//   position: relative;
//   bottom: 0;
//   .top {
//     height: 10px;
//     background: url(../assets/main/footer_bg.png) repeat-x;
//     background-size: 15%;
//   }
//   .content {
//     display: flex;
//     margin: 30px 12%;
//     .qr {
//       flex: 0 1 30%;
//       margin-right: 10px;
//       img {
//         width: 100px;
//       }
//     }
//     .info {
//       flex: 1 0 70%;
//       font-size: 10px;
//       text-align: left;
//       padding-left: 10px;
//       margin-top: 3px;
//       box-sizing: border-box;
//       h5 {
//         font-size: 11px;
//         color: #1d4f48;
//       }
//       p {
//         line-height: 20px;
//         margin-bottom: 0;
//       }
//     }
//   }
// }
</style>
